import React, { useState } from "react";
import { TextField, Button, Grid } from "@material-ui/core";
import { useAuth } from "../../config/AuthContext";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%",
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      width: "98%",
    },
    "& .MuiButton-root": {
      color: theme.palette.primary.dark,
    },
  },
  grid: {
    justifyContent: "center",
    alignItems: "center",
  },
}));
const ReplyForm = ({ commentKey, blogKey, setReplyMode }) => {
  const { dbRef, currentUser } = useAuth();
  const [reply, setReply] = useState("");
  const [error, setError] = useState({
    replyError: false,
    replyErrorHelperText: "",
  });
  const classes = useStyles();

  const validateForm = () => {
    if (!reply) {
      setError({
        replyError: true,
        replyErrorHelperText: "Reply cannot be empty!",
      });
      return false;
    }

    return true;
  };

  const handlePostReply = (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      dbRef
        .child(`blogs/${blogKey}/BlogComments/${commentKey}/BlogReplies/`)
        .push({
          Reply: `${reply.slice(0, 1).toUpperCase()}${reply.slice(1)}`,
          Replier: currentUser.displayName,
          ReplyDate: new Date().toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          }),
        });

      setReply("");
      setError({
        replyError: false,
        replyErrorHelperText: "",
      });
      setReplyMode(false);
    }
  };
  return (
    <form className={classes.form}>
      <Grid container className={classes.grid}>
        <Grid item xs={12} sm={10} md={10}>
          <TextField
            color="secondary"
            error={error.replyError}
            id="reply"
            label="Reply to this conversation"
            helperText={error.replyErrorHelperText}
            multiline
            rows={1}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={2} md={2}>
          <Button
            fullWidth
            type="submit"
            onClick={(e) => handlePostReply(e)}
            color="primary"
          >
            Reply
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ReplyForm;
